module.exports = __webpack_public_path__ + "img/safe_active.1de1fda6.svg";